
/* Return false if given element or any of it's parents have display: none
   CSS property. */

import { JsonParseError } from './errors';

// isVisibleElement :: HTMLElement|SvgElement -> Boolean
export const isVisibleElement = el => {
  if (!el) {
    return false;
  }
  else if (el.offsetParent === undefined) {
    return isVisibleElement(el.parentNode);
  }
  else {
    return !!el.offsetParent;
  }
};


export const instantiate = (clazz, ...params) => {
  const isBabel = clazz.__esModule && clazz.default;
  return isBabel ? new clazz.default(...params) : new clazz(...params);
};


/**
 * Insert sort
 * @template T
 * @param {(t: T) => string | number} valueFn 
 * @returns {(arr: T[], item: T) => T[]}
 */
export const insertItem = valueFn => (arr, item) => {
  const value = valueFn(item);
  return [
    ...arr.filter(n => valueFn(n) <= value),
    item,
    ...arr.filter(n => valueFn(n) > value)
  ];
};

/**
 * 
 * @param {Response} response
 */
export async function parseJSON (response) {
  const body = await response.text();
  try {
    return JSON.parse(body);
  } catch (error) {
    throw new JsonParseError(response, body);
  }
}